import axios from 'axios';
import qs from 'qs';
import { noneToEmptyStr } from '@/util';
import router from '@/router';
if (process.env.NODE_ENV === 'development') {
  // dev url
  axios.defaults.baseURL = '/dev-api/';
} else {
  // build url
  axios.defaults.baseURL = '/api/';
}


axios.defaults.withCredentials = true;

// 返回错误码处理
function errorCodeHandle(codeStatus) {
  switch (codeStatus) {
    case 401:
      router.push({ name: 'login' });
  }
}

// 表单请求
axios.formRequest = axios.create({
  baseUrl: axios.defaults.baseURL,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
  },
  transformRequest: [
    function(data) {
      if (Object.prototype.toString.call(data) === '[object Object]') {
        for (let k in data) {
          data[k] = noneToEmptyStr(data[k]);
        }
      }
      return qs.stringify(data, { arrayFormat: 'indices' });
    }
  ]
});
axios.formRequest.interceptors.request.use(
  function(config) {
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

axios.formRequest.interceptors.response.use(
  function(response) {
    return response.data;
  },
  function(error) {
    if (error.response) {
      errorCodeHandle(error.response.status);
    }

    return Promise.reject(error);
  }
);

export default axios;